/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Fragment, PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;
  path {
    fill: #bf3030;
  }
`
export default class LiveIco extends PureComponent {
  render() {
    return (
      <Fragment>
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" css={Color}>
          <path
            d="M50.96,17.04A23.117,23.117,0,0,0,34,10a23.117,23.117,0,0,0-16.96,7.04A23.117,23.117,0,0,0,10,34a23.117,23.117,0,0,0,7.04,16.96A23.117,23.117,0,0,0,34,58a23.117,23.117,0,0,0,16.96-7.04A23.117,23.117,0,0,0,58,34a23.117,23.117,0,0,0-7.04-16.96M40,19.36a1.3,1.3,0,0,1-.24.8L35.6,24.4h9.6a4.586,4.586,0,0,1,3.28,1.52A4.832,4.832,0,0,1,50,29.2v16a4.832,4.832,0,0,1-1.52,3.28A4.411,4.411,0,0,1,45.2,50H22.8a4.85,4.85,0,0,1-3.36-1.52A4.448,4.448,0,0,1,18,45.2l-.08-16.16a4.443,4.443,0,0,1,1.52-3.12A4.85,4.85,0,0,1,22.8,24.4h9.6l-4-4.24a1.16,1.16,0,0,1,0-1.6l.24-.24a1.281,1.281,0,0,1,.8-.32,1.085,1.085,0,0,1,.8.32l4,3.92,3.52-3.84a.985.985,0,0,1,.8-.4,1.085,1.085,0,0,1,.8.32l.32.24a1.555,1.555,0,0,1,.32.8m5.84,9.2a3.253,3.253,0,0,0-2.24-.96H24.4a3.281,3.281,0,0,0-3.2,3.2V43.6a3.253,3.253,0,0,0,.96,2.24,3.07,3.07,0,0,0,2.24.96H43.6a3.281,3.281,0,0,0,3.2-3.2V30.8a3.07,3.07,0,0,0-.96-2.24M31.52,33.2h.16l5.2,4a.6.6,0,0,1,0,.96l-5.2,3.92-.08.08-.24.08a.424.424,0,0,1-.48-.48V33.6a.424.424,0,0,1,.48-.48Z"
            transform="translate(-10 -10)"
            fill="#bf3030"
          />
        </svg>
      </Fragment>
    )
  }
}
